import React, {memo} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {hideKeyboard} from '@/actions/modalActions';
import KeyboardModal from '@/components/keyboard/KeyboardModal';
import {getMainVirtualKeyboard} from '@/selectors/modalSelector';

function MainVirtualKeyboard() {
  const dispatch = useDispatch();
  const {
    keyboardVisible,
    keyboardValue,
    keyboardTitle,
    keyboardCallBack,
    overwriteFirstInput,
    keyboardPlaceholder,
    max,
    keyboardCancel,
    disableSymbols,
  } = useSelector(getMainVirtualKeyboard);

  const handleOnHide = () => {
    dispatch(hideKeyboard());
  };

  return (
    <KeyboardModal
      keyboardVisible={keyboardVisible}
      keyboardValue={keyboardValue}
      keyboardTitle={keyboardTitle}
      keyboardCallBack={keyboardCallBack}
      overwriteFirstInput={overwriteFirstInput}
      keyboardPlaceholder={keyboardPlaceholder}
      max={max}
      keyboardCancel={keyboardCancel}
      disableSymbols={disableSymbols}
      onHide={handleOnHide}
    />
  );
}

export default memo(MainVirtualKeyboard);
